import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import get from 'lodash/get';
import ApiService from '../../../services/apiService';
import viewMixin from './viewMixin';
export default {
  name: 'CoreConsumersChainsEdit',
  mixins: [viewMixin],
  props: {
    accounts: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    selectedAccount: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    consumerModel: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    triggerSources: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    bridgeTypes: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    isCreateDialog: {
      type: Boolean,
      required: true,
      default: true
    }
  },
  data: function data() {
    return {
      newChainItemType: null,
      formValid: false,
      bridges: [],
      account: this.selectedAccount,
      filters: [],
      transformers: [],
      textboxFields: ['payload', 'html', 'text', 'frm_payload']
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled', 'permissions'])), {}, {
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    chainBridgeItem: function chainBridgeItem() {
      var chain = this.consumerModel.chain || [];
      return this.chainHasOneBridge && chain[chain.length - 1].action === 'ds-bridge' ? chain[chain.length - 1] : {};
    },
    chainHasOneBridge: function chainHasOneBridge() {
      return (this.consumerModel.chain || []).filter(function (c) {
        return c.action === 'ds-bridge';
      }).length === 1;
    },
    chainsLastItemIsBridge: function chainsLastItemIsBridge() {
      return this.chainBridgeItem.action === 'ds-bridge';
    },
    chainErrorMessage: function chainErrorMessage() {
      return !this.chainHasOneBridge ? this.$i18n_t('Bridges.Consumers.chains.errors.mustHaveOneConnector') : true;
    },
    chainBridgeRules: function chainBridgeRules() {
      var _this2 = this;

      return [this.requiredRule[0], function () {
        return _this2.chainsLastItemIsBridge || _this2.$i18n_t('Bridges.Consumers.chains.errors.connectorLastStep');
      }];
    },
    chainItemTypes: function chainItemTypes() {
      var filterParam = this.filters.length ? {
        value: 'filter',
        text: this.$i18n_t('Bridges.Consumers.chains.filter')
      } : null;
      var transformerParam = this.transformers.length ? {
        value: 'transform',
        text: this.$i18n_t('Bridges.Consumers.chains.transformer')
      } : null;
      var bridgeParam = this.bridges.length && !this.chainHasOneBridge ? {
        value: 'bridge',
        text: this.$i18n_t('accMgmt.tenant.bridges.title')
      } : null;
      return [filterParam, transformerParam, bridgeParam].filter(function (v) {
        return v;
      });
    },
    chainItemsTableHeader: function chainItemsTableHeader() {
      return [{
        value: 'order',
        text: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.order'),
        sortable: false
      }, {
        text: this.$i18n_t('Bridges.Consumers.chains.item'),
        sortable: false
      }];
    },
    getColumnWidth: function getColumnWidth() {
      var _this3 = this;

      return function (param, paramConfig) {
        if (paramConfig.width && ['m', 'l'].indexOf(paramConfig.width) >= 0) {
          return param.width === 'm' ? 6 : 12;
        }

        return _this3.textboxFields.includes(param) ? 12 : 4;
      };
    }
  }),
  watch: {
    formValid: function formValid() {
      this.$emit('change-valid-form', this.formValid);
    },
    account: function account(_account) {
      this.setBridgeConfigs(_account);
      this.fetchTransformers([_account], {
        'loading-flag': false
      });
      this.fetchFilters([_account], {
        'loading-flag': false
      });
      this.consumerModel.chain = [];
      this.newChainItemType = null;
    }
  },
  created: function created() {
    if (!this.selectedAccount) {
      return;
    }

    this.setBridgeConfigs(this.selectedAccount);
    this.fetchTransformers([this.selectedAccount], {
      'loading-flag': false
    });
    this.fetchFilters([this.selectedAccount], {
      'loading-flag': false
    });
  },
  methods: {
    /** these rules make sure that the content-types of filter/transformer steps are compatible
     *  e.g. if a transformer outputs XML and a filter requires JSON, then the UI shall complain about it.
     */
    transformerOrFilterRule: function transformerOrFilterRule(index) {
      var _this4 = this;

      if (index === 0) {
        // the first step obviously has no conditions yet
        return this.requiredRule;
      }

      return [this.requiredRule[0], function () {
        var currentStep = get(_this4.consumerModel.chain, "[".concat(index, "]"));
        var currId = get(currentStep, 'parameter.id');
        var priorStep = get(_this4.consumerModel.chain, "[".concat(index - 1, "]"));
        var priorId = get(priorStep, 'parameter.id');

        if (!currId || !priorId) {
          return true;
        }

        var currentInput = null;
        /* eslint-disable prettier/prettier */

        if (currentStep.action === 'ds-transform') {
          currentInput = get(_this4.transformers.find(function (t) {
            return t.id === currId;
          }), 'transformer.contentTypes.input');
        } else if (currentStep.action === 'ds-filter') {
          currentInput = get(_this4.filters.find(function (f) {
            return f.id === priorId;
          }), 'filter.inputType');
        } // only a transformer as an _output_ type, otherwise it is a filter that does not transform its data
        // so in case the prior step is a filter, just put the current input-type,
        // so the comparision underneath works out fine


        var priorOutput = priorStep.action === 'ds-transform' ? get(_this4.transformers.find(function (t) {
          return t.id === priorId;
        }), 'transformer.contentTypes.output') : currentInput;
        /* eslint-enable prettier/prettier */

        return [currentInput, priorOutput].indexOf('generic') >= 0 || priorOutput === currentInput || _this4.$i18n_t('Bridges.Consumers.chains.errors.incompatibleSteps');
      }];
    },
    parametersForBridgeIdx: function parametersForBridgeIdx(bridgeIdx) {
      var method = this.methodForBridgeIdx(bridgeIdx);
      var params = get(this.methodForBridgeIdx(bridgeIdx), 'methodDef.parameters') || {};
      var bridgeType = method.bridgeType;
      delete params[get(bridgeType, 'manifest.functionScope.extension.consumer.publish.payload')];
      return params;
    },
    methodForBridgeIdx: function methodForBridgeIdx(bridgeIdx) {
      var _this5 = this;

      var bridge = this.bridges.find(function (b) {
        return b.id === get(_this5.chainBridgeItem, "parameter.configs[".concat(bridgeIdx, "].id"));
      });

      if (!bridge) {
        return {};
      }

      var bridgeType = this.bridgeTypes.find(function (b) {
        return b.type === bridge.type;
      });
      var methodName = get(bridgeType, 'manifest.functionScope.extension.consumer.publish.method');
      var methodDef = get(bridgeType, "manifest.commands.instance.".concat(methodName));
      return {
        bridge: bridge,
        bridgeType: bridgeType,
        methodName: methodName,
        methodDef: methodDef
      };
    },
    payloadDescriptionForBridgeIdx: function payloadDescriptionForBridgeIdx(bridgeIdx) {
      var _this6 = this;

      var bridge = this.bridges.find(function (b) {
        return b.id === get(_this6.chainBridgeItem, "parameter.configs[".concat(bridgeIdx, "].id"));
      });

      if (!bridge) {
        return null;
      }

      var payloadKey = "Bridges.Consumers.connectorTypes.".concat(bridge.type.replace('bridge-', ''), ".payloadDescription");
      return this.$i18n_te(payloadKey) ? this.$i18n_t(payloadKey) : null;
    },
    contentTypeForBridgeIdx: function contentTypeForBridgeIdx(bridgeIdx) {
      var _this7 = this;

      var useFallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var _this$methodForBridge = this.methodForBridgeIdx(bridgeIdx),
          bridgeType = _this$methodForBridge.bridgeType,
          methodDef = _this$methodForBridge.methodDef;

      var outputContentType = undefined;
      var encodingParam = get(bridgeType, 'manifest.functionScope.extension.consumer.publish.contentType.parameter');
      var encodingDef = get(methodDef, "parameters.".concat(encodingParam));

      if (encodingDef) {
        var chainSteps = this.consumerModel.chain.map(function (c) {
          switch (c.action) {
            case 'ds-transform':
              return _this7.transformers.find(function (t) {
                return t.id === c.parameter.id;
              });

            case 'ds-filter':
              return _this7.filters.find(function (f) {
                return f.id === c.parameter.id;
              });

            default:
              return null;
          }
        }); // get the latest output type; which does not necessarily have to come from the prior step

        for (var j = this.consumerModel.chain.length - 1; j >= 0; j--) {
          if (this.consumerModel.chain[j].action === 'ds-transform' && chainSteps[j] !== null && chainSteps[j] !== undefined) {
            outputContentType = chainSteps[j].transformer.contentTypes.output;
            break;
          }

          if (this.consumerModel.chain[j].action === 'ds-filter' && chainSteps[j] !== null && chainSteps[j] !== undefined) {
            // otherwise use the INPUT type of filters
            outputContentType = chainSteps[j].filter.inputType;
            break;
          }
        }

        var typeMapping = get(bridgeType, 'manifest.functionScope.extension.consumer.publish.contentType.mapping');
        outputContentType = typeMapping[outputContentType] || (useFallback ? outputContentType : undefined);
      }

      return {
        outputContentType: outputContentType,
        encodingParam: encodingParam
      };
    },
    rulesForBridgeIdx: function rulesForBridgeIdx(bridgeIndex) {
      var _this8 = this;

      return [].concat(_toConsumableArray(bridgeIndex === 0 ? this.chainBridgeRules : this.requiredRule), [function () {
        var contentType = _this8.contentTypeForBridgeIdx(bridgeIndex);

        return (// if the output-type could not be determined (e.g. there is not even a prior step), it is valid
          contentType.outputContentType === undefined || // or it is a "wildcard" content, i.e. anything matches
          contentType.outputContentType === 'generic' || // otherwise the output-type must match
          contentType.outputContentType === get(_this8.chainBridgeItem, "parameter.configs[".concat(bridgeIndex, "].params.").concat(contentType.encodingParam)) || _this8.$i18n_t('Bridges.Consumers.chains.errors.incompatibleSteps')
        );
      }]);
    },
    pickedBridge: function pickedBridge(bridgeIndex) {
      // if a bridge is selected, pre-select the desired output-type according to the current chain, if possible
      // add the `noFallback` flag here, to make sure if no mapping is possible, the outputContentType is undefined,
      // i.e. effectly it is still not set afterward
      var contentType = this.contentTypeForBridgeIdx(bridgeIndex, false);

      if (get(this.chainBridgeItem, 'parameter.configs') && !this.chainBridgeItem.parameter.configs[bridgeIndex][contentType.encodingParam]) {
        this.chainBridgeItem.parameter.configs[bridgeIndex][contentType.encodingParam] = contentType.outputContentType;
      }
    },
    addNewChainItem: function addNewChainItem() {
      var _this9 = this;

      var newItem = {
        action: "ds-".concat(this.newChainItemType),
        parameter: {}
      };

      switch (this.newChainItemType) {
        case 'bridge':
          newItem.parameter.configs = [];
          break;
      }

      this.consumerModel.chain.push(newItem);

      switch (this.newChainItemType) {
        case 'bridge':
          // needs to be called AFTER being pushed to consumerModel
          // is a lil ugly with 2 switch right after another, but seems to be the only way
          this.addBridgeConfig(this.consumerModel.chain.length - 1);
          break;
      }

      this.$nextTick(function () {
        _this9.$refs.form.validate();
      });
    },
    deleteChainItem: function deleteChainItem(index) {
      var _this10 = this;

      pullAt(this.consumerModel.chain, [index]);
      this.consumerModel.chain = cloneDeep(this.consumerModel.chain);
      this.$nextTick(function () {
        _this10.$refs.form.validate();
      });
    },
    changeChainItemOrder: function changeChainItemOrder(currentIndex, direction) {
      var _this11 = this;

      var newIndex = Math.min(this.consumerModel.chain.length - 1, Math.max(0, currentIndex + (direction === 'up' ? -1 : 1)));

      if (newIndex !== currentIndex) {
        var chain = cloneDeep(this.consumerModel.chain);
        var otherObject = chain[newIndex];
        chain[newIndex] = chain[currentIndex];
        chain[currentIndex] = otherObject;
        this.consumerModel.chain = chain;
        this.$nextTick(function () {
          _this11.$refs.form.validate();
        });
      }
    },
    addBridgeConfig: function addBridgeConfig(chainIdx) {
      var _this12 = this;

      this.consumerModel.chain[chainIdx].parameter.configs.push({
        params: {}
      });
      this.$nextTick(function () {
        _this12.$refs.form.validate();
      });
    },
    deleteBridgeConfig: function deleteBridgeConfig(chainIdx, index) {
      var _this13 = this;

      pullAt(this.consumerModel.chain[chainIdx].parameter.configs, [index]);
      this.consumerModel.chain = cloneDeep(this.consumerModel.chain);
      this.$nextTick(function () {
        _this13.$refs.form.validate();
      });
    },
    setBridgeConfigs: function setBridgeConfigs(account) {
      var _this14 = this;

      if (!account) {
        return;
      }

      ApiService.getBridgesForTenant(account.id).then(function (data) {
        data = data.length ? data.map(function (b) {
          var bridgeType = _this14.bridgeTypes.find(function (t) {
            return t.type === b.type;
          });

          b.displayName = bridgeType ? get(bridgeType, 'manifest.displayName') : '';
          return b;
        }) : [];
        _this14.bridges = data.filter(function (b) {
          var type = _this14.bridgeTypes.find(function (t) {
            return t.type === b.type;
          });

          return type && get(type, 'manifest.functionScope.extension.consumer');
        });
      }).catch(function (error) {
        console.error(error);
      });
    }
  }
};